import React, { Component } from 'react';
import { findDOMNode } from "react-dom";
import './resources.css';
import Videostage from '../videostage/videostage';
import { Link, Switch, Route } from 'react-router-dom';
// import AWP from './awp/awp'

class Resources extends Component {
	constructor(props) {
		super(props);
		this.newsStage = React.createRef();
		this.section = [React.createRef(), React.createRef(), React.createRef(), React.createRef(), React.createRef(), React.createRef(), React.createRef()];
		this.state = {
			resources : [],
			part1: [],
			part2: [],
			part3: [],
			part4: [],
			part5: [],
			part5b: [],
			videos: [],
			sliderSize: []                  
		};
	  }

	componentDidMount() {
		this.getResources();
	  }

	componentDidUpdate(){
	   
			
	}
	
	videoClick(e){
		  var previousVid = document.getElementsByClassName('currentVid'); 
		  var currentVideo = (parseInt(e.currentTarget.dataset.id, 10));
		  var currentDom = document.getElementById(currentVideo);
		  previousVid[0].classList.remove('currentVid');
		  currentDom.className += " currentVid";

		  }

	reScrollTo(e) {
		const scrollThis = (parseInt(e.currentTarget.dataset.id, 10));
		var myElement = findDOMNode(this.section[scrollThis].current);
		myElement.scrollIntoView({behavior: "instant", block: "center", inline: "nearest"});
	  }
	
	  // Retrieves the list of items from the Express app
	  getResources = () => {
		fetch('/api/resources')
		.then(res => res.json())
		.then(data=> this.setState({
				resources: data.resources,
				part1: data.part1,
				part2: data.part2,
				part3: data.part3,
				part4: data.part4,
				part5: data.part5,
				part5b: data.part5b,
				videos: data.videos,
			
			}));


		// vidSingle.map(item=>{
		//     this.setState({sliderSize: this.state.sliderSize + item.offsetWidth})
		//     }) 
	
			
		}

	render() {
		const { resources } = this.state;
		const { part1 } = this.state;
		const { part2 } = this.state;
		const { part3 } = this.state;
		const { part4 } = this.state;
		const { part5 } = this.state;
		const { part5b } = this.state;
		const { videos } = this.state;
		var singleVidW = .25;

		if(window.innerWidth < 1000){
			singleVidW= .3;
		}
	   if (window.innerWidth < 900){
			singleVidW = .35;
		}
		if (window.innerWidth < 600){
			singleVidW = .5;

		}

		if (window.innerWidth < 500){
			singleVidW = .6;

		}
 
		
		return (
			<div className="resourceFull mapContent relative" style={{"opacity": this.props.mapVis[2]}} ref={this.newsStage}>
			  {/*<Route exact path="/clapback-chest" render={()=><AWP mapVis={this.state.mapVis}/>} />*/}
				{resources.length ? (
					<div className="fullWidth" >
						{/* Render the list of items */}

						{window.innerWidth >= 900 ? (
							<div className="reNavHold">
								<h1 className="resourceLinks upperT blkT boldT marginBotTiny">Sections</h1>
								<p className="subNav blkT" onClick={this.reScrollTo.bind(this)} data-id="0">The Introduction</p>
								<p className="subNav blkT" onClick={this.reScrollTo.bind(this)} data-id="1">The Longer Reads</p>
								<p className="subNav blkT" onClick={this.reScrollTo.bind(this)} data-id="2">The Longest Reads</p>
								<p className="subNav blkT" onClick={this.reScrollTo.bind(this)} data-id="3">The Dialectics</p>
								<p className="subNav blkT" onClick={this.reScrollTo.bind(this)} data-id="4">On the Same Page</p>
								<p className="subNav blkT" onClick={this.reScrollTo.bind(this)} data-id="5">Videos</p>
								<h1 className="resourceLinks upperT blkT boldT marginTopTiny marginBotTiny">Tools</h1>
								<Link to="/clapback-chest"><p className="subNav blkT">Clapback Chest</p></Link>
						</div>
						):('')}
						
						{resources.map((resources, i) => {
						return(
							<React.Fragment key={i}>
								
								
								<div className="tfStage oneColumnPush marginBotLarge resourceIntro" dangerouslySetInnerHTML={{ __html : resources.resourcesIntro }}></div>
								<h2 className="tfStage oneColumnPush marginBotSmall" dangerouslySetInnerHTML={{ __html : resources.reading1 }} ref={this.section[0]}></h2>
								<div className="tfStage oneColumnPush marginBotLarge part1Intro" dangerouslySetInnerHTML={{ __html : resources.reading1Copy }}></div>
							
									{part1.length ? (
									   
									   <div className="part1 fullStage marginBotLarge">
											{part1.map((item, index)=>{
												return(
												<a href={item.itemURL} target="blank" key={item.id}><div className="resourceItem">
													<div className="resourcePad bgWrap">
												   <div className="resourceInfo">
													<div className="resourceTitle marginBotTiny" dangerouslySetInnerHTML={{ __html : item.itemTitle }}></div>
													<div className="resourceAuthor" dangerouslySetInnerHTML={{ __html :item.itemAuthor }}></div>
												   </div>   
													<div className="resourceCounter">1.{index+1}</div>
												</div>
												</div></a>
												)
											})}
									   </div>
										
									):(     <div className="fullWidth fullHeight redT blinkFast loader">
									<div className="centeredContent">•</div>
								</div> )}
								
								<h2 className="tfStage oneColumnPush marginBotSmall" dangerouslySetInnerHTML={{ __html : resources.reading2 }} ref={this.section[1]}></h2>
								<div className="tfStage oneColumnPush marginBotLarge"dangerouslySetInnerHTML={{ __html : resources.reading2Copy }}></div>
								{part2.length ? (
									   
									   <div className="part2 fullStage marginBotLarge">
											{part2.map((item, index)=>{
												return(
												<a href={item.itemURL} target="blank" key={item.id}><div className="resourceItem">
													<div className="resourcePad bgWrap">
												   <div className="resourceInfo">
													<div className="resourceTitle marginBotTiny" dangerouslySetInnerHTML={{ __html : item.itemTitle }}></div>
													<div className="resourceAuthor" dangerouslySetInnerHTML={{ __html :item.itemAuthor }}></div>
												   </div>   
													<div className="resourceCounter">2.{index+1}</div>
												</div>
												</div></a>
												)
											})}
									   </div>
										
									):(     <div className="fullWidth fullHeight redT blinkFast loader">
									<div className="centeredContent">•</div>
								</div> )}


								<h2 className="tfStage oneColumnPush marginBotSmall" dangerouslySetInnerHTML={{ __html : resources.reading3 }} ref={this.section[2]}></h2>
								<div className="tfStage oneColumnPush marginBotLarge" dangerouslySetInnerHTML={{ __html : resources.reading3Copy }}></div>
								{part3.length ? (
									   
									   <div className="part3 fullStage marginBotLarge">
											{part3.map((item, index)=>{
												return(
												<a href={item.itemURL} target="blank" key={item.id}><div className="resourceItem">
													<div className="resourcePad bgWrap">
												   <div className="resourceInfo">
													<div className="resourceTitle marginBotTiny" dangerouslySetInnerHTML={{ __html : item.itemTitle }} ></div>
													<div className="resourceAuthor" dangerouslySetInnerHTML={{ __html :item.itemAuthor }}></div>
												   </div>   
													<div className="resourceCounter">3.{index+1}</div>
												</div>
												</div></a>
												)
											})}
									   </div>
										
									):(     <div className="fullWidth fullHeight redT blinkFast loader">
									<div className="centeredContent">•</div>
								</div> )}


								<h2 className="tfStage oneColumnPush marginBotSmall" dangerouslySetInnerHTML={{ __html : resources.reading4 }} ref={this.section[3]}></h2>
								<div className="tfStage oneColumnPush marginBotLarge" dangerouslySetInnerHTML={{ __html : resources.reading4Copy }}></div>
								{part4.length ? (
									   
									   <div className="part4 fullStage marginBotLarge">
											{part4.map((item, index)=>{
												return(
												<a href={item.itemURL} target="blank" key={item.id}><div className="resourceItem">
													<div className="resourcePad bgWrap">
												   <div className="resourceInfo">
													<div className="resourceTitle marginBotTiny" dangerouslySetInnerHTML={{ __html : item.itemTitle }}></div>
													<div className="resourceAuthor" dangerouslySetInnerHTML={{ __html :item.itemAuthor }}></div>
												   </div>   
													<div className="resourceCounter">4.{index+1}</div>
												</div>
												</div></a>
												)
											})}
									   </div>
										
									):(    <div className="fullWidth fullHeight redT blinkFast loader">
									<div className="centeredContent">•</div>
								</div> )}


								<h2 className="tfStage oneColumnPush marginBotSmall" dangerouslySetInnerHTML={{ __html : resources.reading5 }} ref={this.section[4]}></h2>
								<div className="tfStage oneColumnPush marginBotSmall" dangerouslySetInnerHTML={{ __html : resources.reading5Copy }}></div>
								<p className="resourceAuthor boldT upperT marginBotSmall tfStage oneColumnPush titleFont">Historical Focus:</p>
								{part5.length ? (
									   
									   <div className="part5 fullStage marginBotSmall">
											{part5.map((item, index)=>{
												return(
												<a href={item.itemURL} target="blank" key={item.id}><div className="resourceItem">
													<div className="resourcePad bgWrap">
												   <div className="resourceInfo">
													<div className="resourceTitle marginBotTiny" dangerouslySetInnerHTML={{ __html : item.itemTitle }}></div>
													<div className="resourceAuthor" dangerouslySetInnerHTML={{ __html :item.itemAuthor }}></div>
												   </div>   
													<div className="resourceCounter">5a.{index+1}</div>
												</div>
												</div></a>
												)
											})}
									   </div>
										
									):(    <div className="fullWidth fullHeight redT blinkFast loader">
									<div className="centeredContent">•</div>
								</div>)}

								<p className="resourceAuthor boldT upperT marginBotSmall tfStage oneColumnPush titleFont">Strategical Focus:</p>
								{part5b.length ? (
									   
									   <div className="part5b fullStage marginBotLarge">
											{part5b.map((item, index)=>{
												return(
												<a href={item.itemURL} target="blank" key={item.id}><div className="resourceItem">
													<div className="resourcePad bgWrap">
												   <div className="resourceInfo">
													<div className="resourceTitle marginBotTiny" dangerouslySetInnerHTML={{ __html : item.itemTitle }}></div>
													<div className="resourceAuthor" dangerouslySetInnerHTML={{ __html :item.itemAuthor }}></div>
												   </div>   
													<div className="resourceCounter">5b.{index+1}</div>
												</div>
												</div></a>
												)
											})}
									   </div>
										
									):( 
									<div className="fullWidth fullHeight redT blinkFast loader">
									<div className="centeredContent">•</div>
								</div>)}



								<h2 className="tfStage oneColumnPush marginBotSmall" ref={this.section[5]}>Videos</h2>
								<div ref={this.section[6]} className="tfStage oneColumnPush marginBotLarge" dangerouslySetInnerHTML={{ __html : resources.videoCopy }}></div>
								<Switch>
									<Route path="/resource-guide/:id" render={()=><Videostage/>} />
									<Route path="/resource-guide" render={()=><Videostage />} />
								</Switch>
							<div className="shadowHold relative fullStage marginTopTiny">
							   <div className="leftShadow gradShadow multiplyB"></div>
							   <div className="gradShadow multiplyB rightShadow"></div>
								<div className=" sliderView fullWidth relative">
								<div className="videoSlider clearBoth" style={{"width" : ((this.newsStage.current.offsetWidth*singleVidW)*this.state.videos.length) + ((30)*this.state.videos.length)+ "px"}}  >
											{videos.map((item, index)=>{
												return(
													<Link to={"/resource-guide/"+item.id} key={item.id}>
												<div id={item.id} className={"videoSingle relative floatLeft relative" + (index === 0 ? ' currentVid' : '') } data-id={item.id} style={{"width" : (this.newsStage.current.offsetWidth*singleVidW)+"px",'margin':"15px"}} onClick={this.videoClick.bind(this)}>
													<div className="videoStandIn"></div>
													<div className="videoSingleTitle resourceTitle centerT"><span className="centeredContent" dangerouslySetInnerHTML={{ __html : item.itemTitle }}></span></div>
													<div className="videoCounter whiteT">{index+1}</div>                            
									
												</div></Link>
										
												)
											})}
								</div>
								</div>
							</div>
					
								  
								
							</React.Fragment>
						);
						})}
					</div>
					) : (
						<div className="fullWidth fullHeight redT blinkFast loader">
						<div className="centeredContent">•</div>
					</div>
					
					)
				}

				
			</div>
		)
	}
  }
  
  export default Resources




// WEBPACK FOOTER //
// ./src/components/resources/resources.js